import dateFns from 'date-fns';

export default function isInSameDay(date1, date2) {
  return dateFns.differenceInCalendarDays(date1, date2) === 0;
}

export function isInSameDayWithPresentDate(date) {
  return dateFns.differenceInCalendarDays(date, new Date()) === 0;
}
